export default {
  methods: {
    scrollToField (ev) {
      this.$nextTick(() => ev.target.scrollIntoView())
    },
  },
}
